(function (window, document) {
  'use strict';

  function select(list, tab, focus) {
    var tabs = Array.prototype.slice.call(list.querySelectorAll('[role=tab]'));
    tabs.forEach(function (t) {
      var on = t === tab;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.classList.toggle('is-active', on);
      t.tabIndex = on ? 0 : -1;
      var panel = document.getElementById(t.getAttribute('aria-controls'));
      if (!panel) return;
      panel.hidden = !on;
      var hook = on && panel.getAttribute('data-tab-shown');
      if (hook && typeof window[hook] === 'function') setTimeout(window[hook], 0);
    });
    if (focus) tab.focus();
    if (window.JN && window.JN.pillFit) window.JN.pillFit();
  }

  function wire(list) {
    var tabs = Array.prototype.slice.call(list.querySelectorAll('[role=tab]'));
    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { select(list, tab); });
      tab.addEventListener('keydown', function (e) {
        var step = {ArrowRight: 1, ArrowLeft: -1}[e.key];
        if (step && document.dir === 'rtl') step = -step;
        if (step) { e.preventDefault(); select(list, tabs[(i + step + tabs.length) % tabs.length], true); }
        if (e.key === 'Home') { e.preventDefault(); select(list, tabs[0], true); }
        if (e.key === 'End') { e.preventDefault(); select(list, tabs[tabs.length - 1], true); }
      });
    });
  }

  function init() { document.querySelectorAll('[data-tabs]').forEach(wire); }

  window.JN = window.JN || {};
  window.JN.tabs = { init: init, select: select };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})(window, document);
